<template>
    <div class="buyCar">
        <div class="null_buyCar" v-if="buyCarListInfo.length === 0">
            <img src="../../assets/images/buyCar/nullBuyCar.png">
            <br>
            <span>您的购物车空空如也~</span><span @click="goShopFunc()">选购商品</span>
        </div>
        <div class="buyCar_list" v-if="ticketsCarListInfo.length !== 0">
            <buyCarPart v-for="(item,index) in ticketsCarListInfo" :key="index" :goodsInfo="item" @changeSelectedStatus="changeSelectedStatusFunc($event)"></buyCarPart>
        </div>

        <div class="buyCar_list" v-if="hotelsCarListInfo.length !== 0">
            <buyCarPart v-for="(item,index) in hotelsCarListInfo" :key="index" :goodsInfo="item" @changeSelectedStatus="changeSelectedStatusFunc($event)"></buyCarPart>
        </div>

        <div class="buyCar_list" v-if="foodsCarListInfo.length !== 0">
            <buyCarPart v-for="(item,index) in foodsCarListInfo" :key="index" :goodsInfo="item" @changeSelectedStatus="changeSelectedStatusFunc($event)"></buyCarPart>
        </div>

        <div class="buyCar_list" v-if="yearCardsCarListInfo.length !== 0">
            <buyCarPart v-for="(item,index) in yearCardsCarListInfo" :key="index" :goodsInfo="item" @changeSelectedStatus="changeSelectedStatusFunc($event)"></buyCarPart>
        </div>

        <div class="all_choose" v-if="buyCarListInfo.length !== 0">
            <div class="all_choose_circle" :class="{beSelectCircle : isAllChoose}" @click="allChooseFunc()"></div>
            <span>全选</span>
            <div class="submit_form">
                {{$t('all_sum')}}<span class="pay_price">￥{{totalMoney}}</span>
                <span class="pay_off" @click="castAccountsFunc()">结算</span>
            </div>
        </div>

    </div>
</template>

<script>
import buyCarPart from "../../components/markets/buyCarPart";

export default {
  name: "buyCar",
  inject: ["reload", "showMsg"],
  data: function() {
    return {
      buyCarListInfo: [], //购物车的全部商品列表,数组
      selectedNumIdArr: [], //一个数组，里面的每个元素是对象，每个对象里面有三个属性，分别是id，goods_num，selected，该数据为改变商品勾选状态时使用
      ticketsCarListInfo: [], //票务商品的列表，数组
      hotelsCarListInfo: [], //酒店商品的列表，数组
      foodsCarListInfo: [], //餐饮商品的列表，数组
      yearCardsCarListInfo: [], //年卡商品的列表，数组
      totalMoney: 0, //购物车中需要结算的商品的总价
      isAllChoose: 0 //是否是全选状态，0：非全选；1：全选
    };
  },
  components: {
    buyCarPart
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    }
  },
  watch: {
    buyCarListInfo: function(n, o) {
      // console.log(n);
      // 循环遍历新值的数组，找出所有类型的商品
      for (var i = 0; i < n.length; i++) {
        if (n[i].cat_id_2 == 854) {
          this.ticketsCarListInfo.push(n[i]);
        } else if (n[i].cat_id_2 == 859) {
          this.hotelsCarListInfo.push(n[i]);
        } else if (n[i].cat_id_2 == 848) {
          this.yearCardsCarListInfo.push(n[i]);
        } else {
          this.foodsCarListInfo.push(n[i]);
        }
      }
    }
  },
  methods: {
    // 获取购物车的列表
    getBuyCarListInfo: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/Cart/index",
        dataType: "json",
        data: {}
      })
        .then(res => {
          // console.log(res);
          this.buyCarListInfo = res.data.cartList;
          // console.log(this.buyCarListInfo);
          this.clearUpDataFormat(this.buyCarListInfo);
          // 获得结算价格总价的方法
          this.getTotalMoneyFunc();
          // 查看是否是全选状态，执行相应的方法
          this.isAllChooseFunc(this.selectedNumIdArr);
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    // 查看是否是全选状态
    isAllChooseFunc: function(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (!arr[i].selected) {
          this.isAllChoose = 0;
          return false;
        }
      }
      this.isAllChoose = 1;
    },
    // 去购物的方法
    goShopFunc: function() {
      this.$router.push({ path: "market" });
    },
    // 整理selectedNumIdArr数据结构的方法
    clearUpDataFormat: function(arr) {
      for (var i = 0; i < arr.length; i++) {
        let obj = {};
        obj.id = arr[i].id;
        obj.goods_num = arr[i].goods_num;
        obj.selected = arr[i].selected;
        this.selectedNumIdArr.push(obj);
      }
    },
    changeSelectedStatusFunc: function(data) {
      // console.log(data);
      for (var i = 0; i < this.selectedNumIdArr.length; i++) {
        if (this.selectedNumIdArr[i].id == data.id) {
          this.selectedNumIdArr[i] = data;
        }
      }
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/Cart/AsyncUpdateCart",
        dataType: "json",
        data: {
          cart: this.selectedNumIdArr
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.reload();
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    getTotalMoneyFunc: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/Cart/AsyncUpdateCart",
        dataType: "json",
        data: {
          cart: this.selectedNumIdArr
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.totalMoney = res.data.result.total_fee;
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    allChooseFunc: function() {
      if (this.isAllChoose) {
        this.isAllChoose = 0;
        for (let i = 0; i < this.selectedNumIdArr.length; i++) {
          this.selectedNumIdArr[i].selected = 0;
        }
      } else {
        this.isAllChoose = 1;
        for (let i = 0; i < this.selectedNumIdArr.length; i++) {
          this.selectedNumIdArr[i].selected = 1;
        }
      }
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/Cart/AsyncUpdateCart",
        dataType: "json",
        data: {
          cart: this.selectedNumIdArr
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status === 1) {
            this.reload();
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    // 点击结算所触发的方法
    castAccountsFunc: function() {
      // 先检验是否登陆
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/User/checkLogin",
        dataType: "json",
        data: {
          cart: this.selectedNumIdArr
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            if (res.data.result) {
              this.checkOutOrder();
            } else {
              this.showMsg("请先登陆");
              // 等1.5秒跳到登录页面
              setTimeout(() => {
                this.$router.push({ path: "/login" });
              }, 1500);
            }
          } else {
            this.showMsg("网络错误,请稍后再试");
          }
        })
        .catch(() => {
          this.showMsg("网络错误,请稍后再试");
        });
    },
    // 点击结算,验证完登陆后所触发的方法
    checkOutOrder: function() {
      // 判断是否有选中的商品,如果没有选中的商品的话,禁止跳转,让用户勾选需要购买的商品
      let ischeckedFlag = false;
      for (var i = 0; i < this.selectedNumIdArr.length; i++) {
        if (this.selectedNumIdArr[i].selected) {
          ischeckedFlag = true;
        }
      }

      if (ischeckedFlag) {
        // this.showMsg("结算成功");
        this.$http({
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          method: "post",
          url: this.weburl + this.hurl + "/Cart/checkCart",
          dataType: "json",
          data: {}
        })
          .then(res => {
            if (res.data.status === 1) {
              // 把需要结算的购物车信息记录在localStorage里面
              localStorage.setItem(
                "buyCarOrderInfo",
                JSON.stringify(res.data.result.cartList)
              );
              localStorage.setItem(
                "cartPriceInfo",
                JSON.stringify(res.data.result.cartPriceInfo)
              );
              this.$router.push({ path: "/order", query: { to_order_way: 0 } });
            } else {
              this.showMsg("网络错误,请稍后再试");
            }
          })
          .catch(err => {
            this.showMsg("网络错误,请稍后再试");
          });
      } else {
        this.showMsg("请选择您要结算的商品");
      }
    }
  },
  created: function() {
    this.getBuyCarListInfo();
    this.$store.commit("set_current", 6);
    this.$store.commit("set_title", "shop_cart");
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";
.buyCar {
  width: @width;
  background: @bg;
  padding: @font 0;
  .buyCar_list {
    padding: 0.5rem 0;
    .box-shadow;
  }
  .buyCar_list,
  .all_choose {
    background-color: #fff;
    .border-radius(10px);
    margin: 15px auto;
    width: 96%;
  }
  .all_choose {
    margin-top: 30px;
    height: 53px;
    line-height: 53px;
    position: relative;
    font-size: @font - 0.2;
    padding-left: 10%;
    .box-sizing;
    // &:before{
    //     content: '';
    //     width:@font;
    //     height: @font;
    //     top: 17px;
    //     left: 3%;
    //     .border-radius(50%);
    //     .border(1px; solid;@word);
    // }
    .submit_form {
      float: right;
      width: 70%;
      height: @width;
      .pay_price {
        color: @subject_color;
        margin-right: 10px;
      }
      .pay_off {
        color: #fff;
        font-size: @font + 0.1;
        background: @brick_red;
        text-align: center;
        height: @width;
        width: 48%;
        float: right;
        .border-radius(0 10px 10px 0);
      }
    }
  }
}

.all_choose_circle {
  content: "";
  width: @font;
  height: @font;
  top: 17px;
  left: 3%;
  .border-radius(50%);
  .border(1px; solid; @word);
  position: absolute;
}
.beSelectCircle {
  background: url("@{sprite}") no-repeat -197px -16px;
  background-size: 238px auto;
}

.null_buyCar {
  text-align: center;
  // position: relative;
  // top: 150px;
  margin-top: 100px;
}
.null_buyCar span:nth-of-type(1) {
  font-size: 20px;
  font-weight: bold;
}
.null_buyCar span:nth-of-type(2) {
  display: inline-block;
  width: 100px;
  height: 30px;
  font-size: 20px;
  font-weight: bold;
  line-height: 30px;
  background-color: #7e282e;
  color: white;
  border-radius: 10px;
}
.null_buyCar img {
  width: 130px;
}
</style>

<style scoped lang="less">
.buyCar {
  @media (min-width: 410px) {
    min-height: 527px;
  }
  @media (max-width: 375px) {
    min-height: 452px;
  }
  @media (max-width: 360px) {
    min-height: 426px;
  }
  @media (max-width: 320px) {
    min-height: 348px;
  }
}
</style>
